module.exports = __webpack_public_path__ + "img/world-map.902ab807.png";